export default "__VITE_PUBLIC_ASSET__8763fda6__"